import React from 'react';
import cx from 'classnames';
import s from './Footer.css';
import {string, object} from "prop-types";
import {connect} from "react-redux";


const Footer = ({ ...props }) => {
    // TOS link Updox Terms of Service
    // https://updox.com/termsofservice/
    // Privacy Policy Updox Privacy Policy
    // https://updox.com/privacy-policy/
    const showTermsAndConditions = props.publicState.termsAndConditionsLink && props.publicState.termsAndConditionsLink !== "";

    const updoxTermsOfServiceUrl = props.publicState.updoxTermsOfServiceUrl ? props.publicState.updoxTermsOfServiceUrl.trim() : null;
    const showUpdoxTermsOfServiceUrl = updoxTermsOfServiceUrl && updoxTermsOfServiceUrl !== "" && updoxTermsOfServiceUrl.length > 0;

    const updoxPrivacyPolicyUrl = props.publicState.updoxPrivacyPolicyUrl ? props.publicState.updoxPrivacyPolicyUrl.trim() : null;
    const showUpdoxPrivacyPolicyUrl = updoxPrivacyPolicyUrl && updoxPrivacyPolicyUrl !== "" && updoxPrivacyPolicyUrl.length > 0;

    return (
        <div className='footer-flex-container'>
            <ul className='footer-links'>
                {showUpdoxTermsOfServiceUrl &&
                    <li><a href={updoxTermsOfServiceUrl} target="_blank">Updox Terms of Service</a></li>
                }
                {showUpdoxPrivacyPolicyUrl &&
                    <li><a href={updoxPrivacyPolicyUrl} target="_blank">Updox Privacy Policy</a></li>
                }
                {showTermsAndConditions &&
                    <li><a href={props.publicState.termsAndConditionsLink} target="_blank" referrerPolicy="no-referrer">Practice Terms and Conditions</a></li>
                }
            </ul>
        </div>
    )
}

Footer.propTypes = {
    publicState: object,
};

const mapStateToProps = (state) => ({
    publicState: state.publicState
});

export default connect(mapStateToProps, null)(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js